import React from 'react'
import { findDOMNode } from 'react-dom'
import { SidePanel, ROLE_SIDE_PANEL } from '../ThreePanelLayout'
import styles from './StickyHeaderSidePanel.scss'
import _ from 'lodash'
import cx from 'classnames'
import { Topo } from 'common/styleguide/Topo'

export class StickyHeaderSidePanel extends React.PureComponent {
  static role = ROLE_SIDE_PANEL

  state = {
    scrollTop: 0,
    headerHeight: 9999,
    collapseHeight: 0
  }

  componentDidMount () {
    window.addEventListener('resize', this.throttledOnResize)
    this.onResize()
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.throttledOnResize)
  }

  onResize = () => {
    const headerNode = findDOMNode(this._stickyHeader)
    headerNode && this.setState({ collapseHeight: headerNode.scrollHeight })
  }

  throttledOnResize = _.throttle(this.onResize, Math.floor(1000 / 60))

  onContentScroll = (e) => {
    this.throttledOnContentScroll(e.target.scrollTop)
  }

  throttledOnContentScroll = _.throttle(
    (scrollTop) => this.setState({
      scrollTop,
      headerHeight: findDOMNode(this._scrollingHeader).scrollHeight
    }),
    Math.floor(1000 / 60), // aim for a 60fps header animation
    { leading: true }
  )

  render () {
    const { headerHeight, scrollTop, collapseHeight } = this.state
    const showCollapsedHeader = (headerHeight - scrollTop) <= collapseHeight
    const { stickyHeader, scrollingHeader, children } = this.props

    return <SidePanel className={styles.StickyHeaderSidePanel} onScroll={this.onContentScroll}>
      <Topo
        dark
        ref={r => { this._stickyHeader = r }}
        className={cx(styles.stickyHeader, showCollapsedHeader && styles.stickyHeaderVisible)}>
        {stickyHeader}
      </Topo>
      <div className={styles.scrollContainer}>
        <div ref={r => { this._content = r }} className={styles.scrollContent}>
          {scrollingHeader && <Topo dark ref={r => { this._scrollingHeader = r }}>{scrollingHeader}</Topo>}
          {children}
        </div>
      </div>
    </SidePanel>
  }
}
